import FAQSection from '../landing/FAQSection';

export const PartnerLandingFAQSection = ({ partnerName }: { partnerName: string }) => (
  <FAQSection
    itemsClassName='max-w-3xl mx-auto'
    items={[
      {
        question: 'Is it really free?',
        answer: (
          <p>
            Yes - it's really free! There are no hidden fees, no trial periods, and no upsells. Our work is fully funded by corporate partners who are investing in the social enterprise movement—by sharing their employees, networks, and resources to help you grow. That’s what makes it possible for us to offer personalized support at no cost to you.
          </p>
        ),
      },
      {
        question: `Why is ${partnerName} offering this?`,
        answer: (
          <div className='flex flex-col gap-2'>
            <p>
              {partnerName} recognizes that social enterprises often need more than funding to grow. This partnership is designed to provide practical, hands-on business support — helping organizations like yours strengthen operations, increase revenue, and expand impact. MovingWorlds serves as the delivery partner to make this support accessible.
            </p>
          </div>
        ),
      },
      {
        question: 'What kind of support can I get?',
        answer: (
          <div className='flex flex-col gap-2'>
            Social enterprises receive support from experienced professionals from leading global companies who volunteer their expertise through structured programs and project collaborations. Examples include:
            <ul className='mt-2 list-disc ml-4'>
              <li>
                Strategic coaching from consultants at companies like EY to help refine strategy, leadership, and growth plans
              </li>
              <li>
                Hands-on project support from teams at companies like SAP, helping implement solutions related to technology, operations, digital systems, and more
              </li>
            </ul>
            <p>
              This support is practical and tailored to your needs—helping you solve real business challenges and strengthen your organization.
            </p>
          </div>
        ),
      },
      {
        question: 'How much time do I need to commit?',
        answer: (
          <div>
            We know your time is limited—that's why our support is flexible and on-demand. To get the most out of the platform, we recommend:
            <ul className='mt-2 list-disc ml-4'>
              <li>
                About 2 hours per week in your first month to explore opportunities, post your first project, and engage with the community.
              </li>
              <li>
                As little as 20 minutes per week after that to stay connected and access new resources as needed. You're in control—and the more you engage, the more value you'll unlock.
              </li>
            </ul>
          </div>
        ),
      },
      {
        question: 'What are the application requirements?',
        answer: (
          <div className='flex flex-col gap-2'>
            <p>
              The application takes about 25 minutes to complete. You'll be asked a few questions about your business—like your team size, revenue, and funding—so it helps to have those details ready.
            </p>
          </div>
        ),
      },
    ]}
  />
);

